import { getRequest, postRequest, putRequest } from "./ServiceHelper";

import {
  createOutcomeConfigurationUrl,
  getOutcomeConfigurationUnapprovedCountUrl,
  getOutcomeConfigurationUrl,
  getQualityCheckProgressUrl,
  updateOutcomeConfigurationUrl,
} from "../config/Config";

export class QualityCheckService {
  static getOutcomeConfiguration = () => {
    return getRequest(getOutcomeConfigurationUrl());
  };

  static getQualityCheckProgress = () => {
    return getRequest(getQualityCheckProgressUrl());
  };

  static createOutcomeConfiguration = (data) => {
    return postRequest(createOutcomeConfigurationUrl(), data);
  };

  static updateOutcomeConfiguration = (id, data) => {
    // convert string ints to numbers
    const config = { ...data };
    Object.keys(config).forEach((key) => {
      if (config[key] === "") {
        config[key] = null;
      } else if (
        isNaN(config[key]) === false &&
        key !== "noPolicyChecked" &&
        key !== "noVariantPolicyChecked" &&
        key !== "atLeastChecked" &&
        key !== "maxChecked"
      ) {
        config[key] = Number(config[key]);
      }
    });
    return putRequest(updateOutcomeConfigurationUrl(id), config);
  };

  static getUnapprovedOutcomeCount = () => {
    return getRequest(getOutcomeConfigurationUnapprovedCountUrl());
  };
}
